import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleHero from "./components/ArticleHero";
import ArticleContent from "./components/ArticleContent";
import RelatedArticles from "./components/RelatedArticles";
import ArticleCTA from "./components/ArticleCTA";

export default function ArtigoGuia() {
  return (
    <>
      <Navbar />
      <main>
        <ArticleHero />
        <ArticleContent />
        <RelatedArticles />
        <ArticleCTA />
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "Guia Completo: Como Usar o Hoobuy Spreadsheet em 2026",
          "description": "Guia completo em português sobre como usar o Hoobuy Spreadsheet para encontrar tênis Nike, Jordan, hoodies e acessórios com links verificados e atualizados diariamente.",
          "author": {
            "@type": "Organization",
            "name": "Equipe Hoobuy Brasil"
          },
          "datePublished": "2026-06-26",
          "dateModified": "2026-06-26",
          "publisher": {
            "@type": "Organization",
            "name": "Hoobuy Spreadsheet Brasil",
            "url": "https://hoobuy.makeup"
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": "https://hoobuy.makeup/hoobuy-spreadsheet-guia"
          }
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://hoobuy.makeup/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Guia Completo do Hoobuy Spreadsheet",
              "item": "https://hoobuy.makeup/hoobuy-spreadsheet-guia"
            }
          ]
        })}
      </script>
    </>
  );
}